import angular from 'angular';
import {Enum} from '../../shared/enum/index';

export class InsurancesOtherController {
  studentDataPage = {};
  filterText = '';

  /*@ngInject*/
  constructor($http, $state, $stateParams, OrderOczfp, insuranceOffer, Document, $scope, LeftNav, $q, pageSettings,
              $element, helper) {
    let vm = this;
    vm.cloakView = true;

    vm.$http = $http;
    vm.Enum = Enum;
    vm.InsurancePerson = insuranceOffer;
    vm.LeftNav = LeftNav;
    vm.pageSettings = pageSettings;
    vm.$state = $state;
    vm.transformStudentsData = data => {
      let copy = angular.copy(data);
      _.each(copy, function(item) {
        item.fullName = item.firstName + ' ' + item.lastName;
      });

      return copy;
    };
    vm.query = {
      page: 1,
      limit: 10,
      query: null,
      criteria: {
        insuranceOfferId: $stateParams.id
      },
      sort: {
        field: 'id',
        order: 'desc'
      }
    };
    vm.selectedCriteria = {};
    vm.insurancePersonStatuses = [];
    vm.paymentStatuses = [];

    _.each(Enum.INSURANCE_PERSON_STATUS, data => {
      helper.translate('ENUM.INSURANCE_PERSON_STATUS.' + data)
        .then(translated => {
          vm.insurancePersonStatuses.push({label: translated, id: data});
        });
    });

    _.each(Enum.PAYMENT_STATUS, data => {
      helper.translate('ENUM.PAYMENT_STATUS.' + data)
        .then(translated => {
          vm.paymentStatuses.push({label: translated, id: data});
        });
    });


    vm.searchInsurancePersonStatusTerm = '';
    vm.searchPaymentStatusTerm = '';
    vm.clearSearchTerm = function() {
      vm.searchInsurancePersonStatusTerm = '';
      vm.searchPaymentStatusTerm = '';
    };
    $element.find('input')
      .on('keydown', function(ev) {
        ev.stopPropagation();
      });


    vm.filterChanged = () => {
      vm.query.query = vm.filterText;
      vm.query.criteria = vm.selectedCriteria;
      OrderOczfp.getDataPage(vm.query)
        .then(vm.success);
    };

    vm.success = insurances => {
      this.insurances = insurances.data;
      vm.deferred.resolve();
    };

    vm.getInsurances = function() {
      vm.deferred = $q.defer();
      vm.promise = vm.deferred.promise;
      OrderOczfp.getDataPage(vm.query)
        .then(vm.success);
    };

    vm.getInsuranceOfferName = () => {
      insuranceOffer.getName($stateParams.id)
        .then(data => {
          vm.offer = data.data;
        });
    };

    vm.getCsvFile = () => {
      let criteria = angular.copy(vm.query);
      criteria.page = 1;
      criteria.limit = null;

      OrderOczfp.getCsvOczfp(criteria)
        .then(function(data) {
          let blob = new Blob([data.data], {type: 'text/plain'});

          // FOR IE:

          if(window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, 'dane.csv');
          } else {
            let e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

            a.download = 'dane.csv';
            a.href = window.URL.createObjectURL(blob);
            a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
            e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
          }
        });
    };

    // LISTENERS
    const loadingBarDisabler = $scope.$on('cfpLoadingBar:completed', function() {
      vm.cloakView = false;
      loadingBarDisabler();
    });

    $scope.$watch('vm.filterText', function(text, oldText) {
      if(oldText) {
        vm.query.query = text;
        vm.promise = OrderOczfp.getDataPage(vm.query)
          .then(vm.success);
      }
    }, true);


    // ACTIONS
    vm.showDetails = insurance => {
      console.log(insurance);
    };

    vm.downloadCertificate = function(item) {
      Document.printOczfp(item.document.id, item.person.email, item.accessToken);
    };
  }

  addStudent() {
    this.$state.go('main.studentAdd');
  }

  $onInit() {
    this.LeftNav.setActive('clients', 'main.students');
    this.pageSettings.setTitle('APPLICATION.TITLE.CALCULATIONS');
    this.pageSettings.setState('main.students');
    this.pageSettings.setTheme('clients');
    this.getInsurances();
    this.getInsuranceOfferName();
  }
}

export default angular.module('ngOskCrmApp.main.insurancesOther', [])
  .component('insurancesOther', {
    template: require('./insurancesOther.pug'),
    controller: InsurancesOtherController,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/insurancesOther/insurancesOther.component.js